import * as React from "react";
import type { SVGProps } from "react";
const SvgSteamRoomIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 28 28"
    {...props}
  >
    <path
      fill="#858585"
      d="M8.68 2.24a4.2 4.2 0 0 0-3.554 1.968.56.56 0 1 0 .948.597A3.07 3.07 0 0 1 8.68 3.36a3.07 3.07 0 0 1 3.079 3.162c-.043 1.682-1.533 2.998-3.247 2.998H2.24a.56.56 0 1 0 0 1.12h6.272c2.29 0 4.307-1.769 4.367-4.09A4.21 4.21 0 0 0 8.68 2.24m12.6 2.24a5.04 5.04 0 0 0-4.41 2.6.561.561 0 1 0 .98.545A3.91 3.91 0 0 1 21.28 5.6a3.91 3.91 0 0 1 3.912 4.163c-.125 2.085-1.97 3.677-4.087 3.677H2.24a.56.56 0 1 0 0 1.12h18.865c2.68 0 5.043-2.025 5.205-4.73a5.05 5.05 0 0 0-5.03-5.35M2.24 17.36a.56.56 0 1 0 0 1.12h11.872c1.714 0 3.204 1.316 3.247 2.998a3.07 3.07 0 0 1-3.079 3.162 3.07 3.07 0 0 1-2.606-1.445.56.56 0 0 0-.573-.266.558.558 0 0 0-.375.863 4.2 4.2 0 0 0 3.554 1.968 4.21 4.21 0 0 0 4.199-4.31c-.06-2.321-2.078-4.09-4.367-4.09z"
    />
  </svg>
);
export default SvgSteamRoomIcon;
